export default "__VITE_ASSET__BfqAKaZk__"